<template>
  <div class="container-fluid px-0 bg-primary-subtle icon-list" v-if="isAuthenticated">
    <div class="d-flex align-items-center">
      <RouterLink class="btn p-2 m-1" :to="TranslationsService.i18nRoute({ name: 'home' })">
        <font-awesome-layers class="fa-3x">
          <font-awesome-icon v-if="$route.name === 'home'" :icon="['far', 'sitemap']" />
          <font-awesome-icon v-else-if="$route.name === 'manage-tenants'" :icon="['far', 'building-memo']" />
          <font-awesome-icon v-else-if="$route.name === 'manage-users'" :icon="['far', 'users-gear']" />
          <font-awesome-icon v-else-if="$route.name === 'profile'" :icon="['fas', 'id-card']" />
          <font-awesome-icon v-else-if="$route.name === 'tenant-site'" :icon="['far', 'building']" />
          <font-awesome-icon v-else-if="$route.name === 'site'" :icon="['far', 'warehouse']" />
          <font-awesome-icon v-else-if="$route.name === 'info'" :icon="['far', 'square-info']" />
          <font-awesome-icon v-else-if="$route.name === 'info-device'" :icon="['fas', 'mobile-screen']" />
          <font-awesome-icon v-else-if="$route.name === 'items'" :icon="['far', 'rectangle-list']" />
          <font-awesome-icon v-else-if="$route.name === 'item'" :icon="['far', 'rectangle-list']" />
          <font-awesome-layers v-else-if="$route.name === 'foreign-items'">
              <font-awesome-icon :icon="['far', 'rectangle-list']" transform="up-4 right-4 shrink-4" />
              <font-awesome-icon :icon="['fas', 'person-dolly']" transform="down-4 left-4 shrink-4" />
          </font-awesome-layers>
          <font-awesome-icon v-else-if="$route.name === 'itemblocks'" :icon="['far', 'kit-medical']" />
          <font-awesome-icon v-else-if="$route.name === 'itemblock'" :icon="['far', 'kit-medical']" />
          <font-awesome-icon v-else-if="$route.name === 'itemblock-create'" :icon="['far', 'kit-medical']" />
          <font-awesome-icon v-else-if="$route.name === 'suppliers'" :icon="['far', 'person-dolly']" />
          <font-awesome-icon v-else-if="$route.name === 'supplier'" :icon="['far', 'person-dolly']" />
          <font-awesome-icon v-else-if="$route.name === 'supplier-create'" :icon="['far', 'person-dolly']" />
          <font-awesome-icon v-else-if="$route.name === 'labels-box'" :icon="['far', 'tag']" />
          <font-awesome-icon v-else-if="$route.name === 'stocks'" :icon="['far', 'boxes-stacked']" />
          <font-awesome-icon v-else-if="$route.name === 'stock-changes'" :icon="['fas', 'plus-minus']" />
          <font-awesome-icon v-else-if="$route.name === 'stock-change'" :icon="['fas', 'plus-minus']" />
          <font-awesome-icon v-else-if="$route.name === 'stock-demand'" :icon="['fas', 'shelves']" />
          <font-awesome-icon v-else-if="$route.name === 'biExpiry'" :icon="['far', 'hourglass-clock']" />
          <font-awesome-icon v-else-if="$route.name === 'biItemIssues'" :icon="['far', 'chart-simple-horizontal']" />
          <font-awesome-icon v-else-if="$route.name === 'orders'" :icon="['far', 'cart-shopping']" />
          <font-awesome-icon v-else-if="$route.name === 'order'" :icon="['far', 'cart-shopping']" />
          <font-awesome-icon v-else-if="$route.name === 'order-create'" :icon="['far', 'cart-shopping']" />
          <font-awesome-icon v-else-if="$route.name === 'order-manage'" :icon="['far', 'cart-shopping']" />
          <font-awesome-layers v-else-if="$route.name === 'order-demand'">
            <font-awesome-icon :icon="['far', 'cart-shopping']" transform="up-4 right-4 shrink-4" />
            <font-awesome-icon :icon="['fas', 'shelves']" transform="down-4 left-4 shrink-4" />
          </font-awesome-layers>
          <font-awesome-icon v-else-if="$route.name === 'receivings'" :icon="['far', 'clipboard-list-check']" />
          <font-awesome-icon v-else-if="$route.name === 'receiving'" :icon="['far', 'clipboard-list-check']" />
          <font-awesome-icon v-else-if="$route.name === 'deliveries'" :icon="['far', 'truck']" />
          <font-awesome-icon v-else-if="$route.name === 'delivery'" :icon="['far', 'truck']" />
          <font-awesome-icon v-else-if="$route.name === 'delivery-print'" :icon="['far', 'truck']" />
          <font-awesome-icon v-else-if="$route.name === 'consumptions'" :icon="['far', 'clipboard-medical']" />
          <font-awesome-icon v-else-if="$route.name === 'consumption'" :icon="['far', 'clipboard-medical']" />
          <font-awesome-icon v-else-if="$route.name === 'consumption-create'" :icon="['far', 'clipboard-medical']" />
          <font-awesome-icon v-else-if="$route.name === 'stock-receipt'" :icon="['fas', 'plus']" />
          <font-awesome-icon v-else-if="$route.name === 'stock-issue'" :icon="['fas', 'minus']" />
          <font-awesome-icon v-else-if="$route.name === 'labels-item'" :icon="['far', 'qrcode']" />
          <font-awesome-icon v-else-if="$route.name === 'labels-item-capture'" :icon="['far', 'qrcode']" />
          <font-awesome-icon v-else-if="$route.name === 'labels-item-stocks'" :icon="['far', 'qrcode']" />
          <font-awesome-icon v-else-if="$route.name === 'label-printers'" :icon="['far', 'print']" />
          <font-awesome-icon v-else-if="$route.name === 'label-printer'" :icon="['far', 'print']" />
          <font-awesome-icon v-else-if="$route.name === 'label-printer-create'" :icon="['far', 'print']" />
          <font-awesome-icon v-else-if="$route.name === 'label-templates'" :icon="['far', 'file-code']" />
          <font-awesome-icon v-else-if="$route.name === 'label-template'" :icon="['far', 'tag']" />
          <font-awesome-icon v-else-if="$route.name === 'label-template-create'" :icon="['far', 'tag']" />
          <font-awesome-icon v-else :icon="['far', 'square-question']" />
        </font-awesome-layers>
      </RouterLink>
      <div class="d-flex flex-column align-items-start">
        <RouterLink class="btn" :to="TranslationsService.i18nRoute({ name: 'profile' })">
          <font-awesome-icon :icon="['fas', 'id-card']" class="me-1" />
          <span>{{ authUser?.name ?? authUser?.email }}</span>
        </RouterLink>
        <RouterLink class="btn" :to="TranslationsService.i18nRoute({ name: 'site' })">
          <font-awesome-icon :icon="['far', 'warehouse']" class="me-1" />
          <span class="text-truncate">
            <span v-if="selectedTenantName !== ''">{{ selectedTenantName }}</span>
            <span v-else class="text-danger"><font-awesome-icon :icon="['far', 'square-question']" /> {{ $t("menu.tenant") }}</span>
            -
            <span v-if="selectedSiteName !== ''">{{ selectedSiteName }}</span>
            <span v-else class="text-danger"><font-awesome-icon :icon="['far', 'square-question']" /> {{ $t("menu.site") }}</span>
          </span>
        </RouterLink>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { RouterLink } from "vue-router";
import { storeToRefs } from "pinia";
import { useAuthStore, useSessionStore } from "@/stores";
import TranslationsService from "@/services/translations.ts";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

const authStore = useAuthStore();
const { user: authUser, isAuthenticated } = storeToRefs(authStore);

const sessionStore = useSessionStore();
const { userTenants, userSites, selectedTenantId, selectedSiteId } = storeToRefs(sessionStore);

const selectedTenantName = computed(() => {
  const tenant = userTenants.value.find((tenant) => tenant.id === selectedTenantId.value);
  return tenant?.name ?? "";
});
const selectedSiteName = computed(() => {
  const site = userSites.value.find((site) => site.id === selectedSiteId.value);
  return site?.name ?? "";
});
</script>

<style scoped>
.icon-list a {
  color: #3c618c;
}

.icon-list a.active {
  color: #ccc;
  background-color: #3c618c;
}

.icon-list a.active:hover {
  color: #fff;
  background-color: #333333;
}

.icon-list a:hover {
  color: #fff;
  background-color: #979c4b;
}
</style>
